import render from './render';

window.addEventListener('load', () => {
  render(window.oa);
});
